export enum DocumentState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}
